import React, { Component } from 'react';
import { List, Avatar } from 'antd';
import moment from 'moment';


export default class SendPositionList extends Component {
  static propTypes = {

  };

  renderItem = (item) => {
console.log(item)
    let sendTimeStr = moment(item.createAt).format('MM-DD HH:mm');
    let desc = (<div><span>投递给</span> <a >{item.companyName}</a> 的 <a>{item.name}</a> 职位 </div>);
    return (<List.Item>
      <List.Item.Meta
        avatar={<Avatar src={item.img} />}
        title={<div> <span>{item.nickName}</span><span>{sendTimeStr}</span>  </div>}
        description={desc}
      />
    </List.Item>)

  }


  render() {
    const { sendPositionList } = this.props;
    return (
      <div className="home-data-tab">
        <List
          bordered={false}
          header=""
          dataSource={sendPositionList}
          renderItem={this.renderItem}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/SendPositionList.js